import { StateToken } from '@ngxs/store';
import { IMeetingRecordingState } from './meeting-recording.state';

export const MEETING_RECORDING_STATE_TOKEN = new StateToken<IMeetingRecordingState>('recording');
